// extracted by mini-css-extract-plugin
export var active = "_8r-d";
export var blink = "_8r-e";
export var container = "_8r-5";
export var controls = "_8r-0";
export var controlsRight = "_8r-1";
export var fakeCursor = "_8r-c";
export var hidden = "_8r-b";
export var quillContainerSmall = "_8r-7";
export var quillEditor = "_8r-6";
export var quillEditorSmall = "_8r-8";
export var quillFormatButtons = "_8r-a";
export var quillToolbar = "_8r-9";
export var removePadding = "_8r-2";
export var state = "_8r-3";
export var stateTitle = "_8r-4";